import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'

export * from './selectors'

export default Loadable(() => import('./ClientSearchGeneral'))
